

export const JobBoardConfirm = {
    JobBoardHeader : `Thanks`,
    JobBoardText : `Your job posting is pending approval and will be available within 24 hours.`,
    JobBoardButton : `Back to My Job Postings`
}

export const JobApplyConfirm = {
    JobApplyHeader : `You successfully applied for this job.`,
    JobApplyText : `Remember, if this office contacts you for any temping shifts, you must report them using the “Book/Report Shift” button.`,
    JobApplyButton : `I understand`
}
export const JobDeleteConfirm = {
    JobDeleteHeader : `You successfully deleted this job.`,
    JobDeleteText : `Your job posting is successfuly deleted, however you can always see it under 'Deleted' section.`,
    JobDeleteButton : `Back to My Job Postings`
}
